import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Confirmation } from '@abp/ng.theme.shared';
import { NavbarService } from '@volo/ngx-lepton-x.core';
import { from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ConfirmationService } from 'src/core/services/confirmation/confirmation.service';
import { CallFacadeService } from '../telephony/services/call-facade.service';
import { CallStatus } from '../telephony/models/call-status.enum';

export const ACTIVE_CALL_STATES = new Set<CallStatus>([
  CallStatus.Ringing,
  CallStatus.Trying,
  CallStatus.Active,
  CallStatus.Held,
  CallStatus.HangingUp,
]);

export const activeCallDeactivateGuard: CanDeactivateFn<unknown> = () => {
  const callFacade = inject(CallFacadeService);
  const confirmationService = inject(ConfirmationService);
  const navbarService = inject(NavbarService);

  if (!ACTIVE_CALL_STATES.has(callFacade.callStatus())) {
    return true;
  }

  return confirmationService
    .warn(
      'AgentDesktop::ActiveCall:NavigationWarningMessage',
      'AgentDesktop::ActiveCall:NavigationWarningTitle',
      { dismissible: false }
    )
    .pipe(
      switchMap(status => {
        if (status !== Confirmation.Status.confirm) {
          navbarService.expandItems();
          return of(false);
        }
        return from(callFacade.hangup()).pipe(map(() => true));
      })
    );
};
